// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yLFl","question":"styles_question__1tMPr","description":"styles_description__38kvn"};